import { render, staticRenderFns } from "./UnitFiles.vue?vue&type=template&id=24825fef&scoped=true"
import script from "./UnitFiles.vue?vue&type=script&lang=js"
export * from "./UnitFiles.vue?vue&type=script&lang=js"
import style0 from "./UnitFiles.vue?vue&type=style&index=0&id=24825fef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24825fef",
  null
  
)

export default component.exports